/**
 * Build spacing function for MUI theme
 *
 * spacing in MUI can be used 2 ways, either a function or an array for
 * discrete values.
 *
 * default value is:
 *      factor => `${factor * 8}px`
 *
 * this specific function is here to allow discrete values to be used,
 * but with linear interpolation for the float values
 */
export function interpolateSpacingArray(values: number[]) {
  return (factor: number): string => {
    const integer = Math.floor(factor);
    const decimal = factor - integer;

    const base = values[integer] ?? (values[1] - values[0]) * integer;
    const next = values[integer + 1] ?? (values[1] - values[0]) * (integer + 1);

    if (decimal === 0) {
      return `${base}px`;
    }

    const interpolated = base + (next - base) * decimal;
    return `${interpolated}px`;
  };
}
